// Thin API client for Hidden Prime Challenge endpoints.
const API_BASE =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_BACKEND_URL) || "";

const json = (r) => {
  if (!r.ok) return r.json().then((e) => Promise.reject(e));
  return r.json();
};

export const createChallenge = (payload) =>
  fetch(`${API_BASE}/api/challenges`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  }).then(json);

export const getChallenge = (id) =>
  fetch(`${API_BASE}/api/challenges/${encodeURIComponent(id)}`, {
    credentials: "include",
  }).then(json);

export const completeChallenge = (id, payload) =>
  fetch(`${API_BASE}/api/challenges/${encodeURIComponent(id)}/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  }).then(json);
